import { Box, Typography } from '@mui/material';
import Hero from 'components/Hero';
import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';
import Footer from './footer';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
const MainLayout = () => {
  return (
    <div style={{ direction: 'rtl' }}>
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
      >
        <div>
          <Box
            sx={{
              position: 'fixed',
              width: '100%',
              background: 'white',
              height: '65px',
              zIndex: 12,
              boxShadow: 3,
              borderRadius:'0px 0px 50px 0px'
            }}
          >
            <Navbar />
          </Box>
        </div>
        <div style={{ flexGrow: 1 }}>
          <div>{<Outlet />}</div>
        </div>
        {/* '#202e39' */}
        <div style={{ background: '#f9fdfc',  }}>
          <Footer />
        </div>
        <div style={{background:"#202e39"}} >
          <div className="container" style={{display:'flex',alignItems:'center',gap:1,color:'white'}} >
          <Typography variant="caption" color={'white'} >
            وزارت ارتباطات و فناوری اطلاعات - سازمان تنظیم مقررات و ارتباطات
            رادیویی ،شماره پروانه FCP ۱۰۰-۹۴-۱۶ © کلیه حقوق مادی و معنوی این
            وبسایت متعلق به شرکت انتقال داده‌های آسیاتک است.
          </Typography>
          <InstagramIcon/>
          <LinkedInIcon/>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MainLayout;
